import React, { Component } from "react";
import { Translate as T, I18n } from "react-redux-i18n";
import styles from "./Players.css";
import Overlay from "../Overlay/Overlay";
import Dialog from "../Dialog/Dialog";

export default class Players extends Component {
  static defaultProps = {
    players: []
  };

  state = { playerName: "" };

  render = () => (
    <Overlay show={this.props.show}>
      <div className={styles.languages}>
        <Dialog
          onClose={this.handleCloseClick}
          heading={I18n.t("players.heading")}
        >
          <div className={styles.wrapper}>
            <nav className={styles.players}>
              {this.renderPlayers()}
              <form
                className={styles.addPlayer}
                onSubmit={this.handleAddPlayerSubmit}
              >
                <label className={styles.icon}>
                  <input
                    type="text"
                    placeholder={I18n.t("players.addPlayer")}
                    className={styles.input}
                    value={this.state.playerName}
                    onChange={this.handleUserNameChange}
                  />
                </label>
                {/*
            <button type="submit" className={styles.submit}>
              <T value="players.submit" />
            </button>
            */}
              </form>
            </nav>
          </div>
        </Dialog>
      </div>
    </Overlay>
  );

  renderPlayers = () =>
    Object.keys(this.props.players).map(playerName => (
      <div
        key={playerName}
        className={`${styles.player} ${this.props.activePlayer === playerName &&
          styles.active}`}
      >
        <button
          className={styles.icon}
          onClick={this.handlePlayerClick(playerName)}
        >
          {playerName}
        </button>
        {this.props.activePlayer !== playerName && (
          <button
            className={styles.remove}
            onClick={this.handleRemoveClick(playerName)}
          >
            <T value="players.remove" />
          </button>
        )}
      </div>
    ));

  handleUserNameChange = e =>
    this.setState({
      playerName: e.target.value
    });

  handleAddPlayerSubmit = e => {
    e.preventDefault();
    this.props.addPlayer(this.state.playerName);
    this.setState({ playerName: "" });
  };

  handlePlayerClick = playerName => () =>
    this.props.setActivePlayer(playerName);

  handleRemoveClick = playerName => () => this.props.removePlayer(playerName);

  handleCloseClick = () => this.props.hidePlayers();
}



// WEBPACK FOOTER //
// ./src/components/Players/Players.js